import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty } from 'lodash';
import SaveIcon from '@mui/icons-material/Save';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddLinkIcon from '@mui/icons-material/AddLink';
import Connectors from '../../../api/Connectors/Connectors';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';

import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

const MapsAdvancedDownloadLinksField = props => {
  const {
    connectors,
    settingsAdvanced,
    listComponentsAdvanced,
    setListComponentsAdvanced,
    setSettingsAdvanced,
    serverConnection
  } = props;
  const [localSettings, setLocalSettings] = React.useState(settingsAdvanced.downloadLinks);
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.DownloadLinksComponent.name
  );
  const [allSources, setAllSources] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.DownloadLinksComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(
    listComponentsAdvanced.DownloadLinksComponent.iconSvg
  );
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.DownloadLinksComponent.libraryIcon
  );

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        DownloadLinksComponent: {
          name: listComponentsAdvanced.DownloadLinksComponent.name,
          show: listComponentsAdvanced.DownloadLinksComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        DownloadLinksComponent: {
          name: listComponentsAdvanced.DownloadLinksComponent.name,
          show: listComponentsAdvanced.DownloadLinksComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const callToBack = async serverProp => {
    const urlFunction = () => {
      let url;
      if (serverProp.serverType === 'IGP') {
        url = `http://${serverProp.ip}:${serverProp.port}/MG/lidar/write_lidar_html`;
      } else if (serverProp.serverType === 'IGPS' || serverProp.serverType === 'input') {
        url = `${serverProp.domain}/MG/lidar/write_lidar_html`;
      }
      return url;
    };
    const response = await fetch(urlFunction(), {
      method: 'POST',
      body: JSON.stringify({
        ftpIp: '',
        ftpPort: '',
        ftpUser: '',
        ftpPassword: '',
        httpPort: '',
        disc: 'data3',
        projectName: 'Request',
        projectPath: '',
        projectsEntwine: '',
        position: ''
      }),
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const respuesta = await response.json();
    setAllSources(respuesta);
  };

  const handleToggle = item => {
    const currentIndex = localSettings.source.findIndex(el => el.name === item.name);
    const newChecked = [...localSettings.source];
    if (currentIndex === -1) {
      newChecked.push(item);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setLocalSettings({ ...localSettings, source: newChecked });
    setSettingsAdvanced(prev => ({
      ...prev,
      downloadLinks: {
        ...prev.downloadLinks,
        source: newChecked
      }
    }));
  };

  React.useEffect(() => {
    if (!isEmpty(settingsAdvanced.downloadLinks.server)) {
      callToBack(settingsAdvanced.downloadLinks.server);
    }
  }, []);

  return (
    <>
      <Box display="column" width="50%" spacing={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <AddLinkIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() => {
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                DownloadLinksComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.DownloadLinksComponent.show
                }
              });
            }}
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={handleIconSelected}
            selectedIcon={iconFontawesome}
            startLibrary={libraryIcon}
            svg={iconSvg}
            startCategorySvg={listComponentsAdvanced.DownloadLinksComponent.cetegorySvg}
          />
        </Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Base de datos</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Base de datos"
            size="small"
            value={localSettings.connector.name}
            onChange={event => {
              const fullConector = connectors.find(element => element.name === event.target.value);
              setSettingsAdvanced(prev => ({
                ...prev,
                downloadLinks: {
                  ...prev.locationSettings,
                  connector: fullConector
                }
              }));
              setLocalSettings({
                ...localSettings,
                connector: fullConector
              });
            }}
          >
            {connectors.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Conexión IPS</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Conexión IPS"
            size="small"
            value={localSettings.server.name}
            onChange={event => {
              const serverSelectedSearch = serverConnection.find(
                element => element.name === event.target.value
              );
              callToBack(serverSelectedSearch);
              setSettingsAdvanced(prev => ({
                ...prev,
                downloadLinks: {
                  ...prev.locationSettings,
                  server: serverSelectedSearch
                }
              }));
              setLocalSettings({
                ...localSettings,
                server: serverSelectedSearch
              });
            }}
          >
            {serverConnection.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box display="column" width="75%" spacing={1}>
        <Typography>Sources</Typography>
        <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
          <List>
            {allSources.map(item => (
              <ListItem key={item.name} button onClick={() => handleToggle(item)}>
                <Checkbox
                  edge="start"
                  checked={localSettings.source.findIndex(el => el.name === item.name) !== -1}
                  tabIndex={-1}
                  disableRipple
                  sx={{
                    color: '#2A3F90',
                    '&.Mui-checked': {
                      color: '#2A3F90'
                    }
                  }}
                />
                <ListItemText primary={item.name} secondary={item.path} />
              </ListItem>
            ))}
          </List>
        </div>
      </Box>
    </>
  );
};

export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !connectionsSub.ready() && !connectorsSub.ready(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGP', 'IGPS'] } }).fetch(),
    connectors: Connectors.find({ deleted: { $eq: 'no' }, type: 'PostgreSQL' }).fetch()
  };
})(MapsAdvancedDownloadLinksField);
MapsAdvancedDownloadLinksField.defaultProps = {
  setListComponentsAdvanced: () => {}
};
MapsAdvancedDownloadLinksField.propTypes = {
  serverConnection: PropTypes.array.isRequired,
  connectors: PropTypes.array.isRequired,
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired
};
